<template>
  <div>
    <v-card
      flat
      class="rounded-lg mt-5 textLight--text pe-3"
      @click="
        navigateToEmployeeProfilePage(
          registrationData.employee && registrationData.employee.user
            ? registrationData.employee.user._id
            : null
        )
      "
      :style="$vuetify.breakpoint.md ? 'font-size: 14px !important;' : ''"
    >
      <v-row align="center" class="pa-0">
        <v-col cols="" md style="width: 250px">
          <div class="font-weight-light">
            <div class="d-flex flex-row justify-start flex-md-row align-center">
              <v-img
                :key="`registration-card_${registrationData._id}`"
                class="rounded-lg ms-3 no-filter"
                height="45"
                max-width="45"
                :src="
                  registrationData.employee &&
                  registrationData.employee.user &&
                  registrationData.employee.user.avatar
                    ? getImage(registrationData.employee.user.avatar)
                    : require('@/app/user-module/assets/images/user-placeholder.png')
                "
                :lazy-src="
                  require('@/app/user-module/assets/images/user-placeholder.png')
                "
                cover
              />

              <div
                class="ms-3 me-0 me-md-3 align-center"
                style="text-align: start"
              >
                <div class="ma-0 subtitle-1 text-ellipse-2">
                  <span>
                    {{
                      registrationData.employee &&
                      registrationData.employee.user &&
                      registrationData.employee.user.firstName
                        ? registrationData.employee.user.firstName
                        : "-"
                    }}
                    {{
                      registrationData.employee &&
                      registrationData.employee.user &&
                      registrationData.employee.user.lastName
                        ? registrationData.employee.user.lastName
                        : ""
                    }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </v-col>

        <v-col cols="" md style="width: 250px">
          <div class="text-ellipse-2 text-start">
            {{
              registrationData.training && registrationData.training.title
                ? getLocalisedValue(registrationData.training.title)
                : "-"
            }}
          </div>
        </v-col>

        <v-col cols="" md style="width: 250px">
          <div class="text-ellipse-2 text-start">
            {{
              registrationData.trainer &&
              registrationData.trainer.user &&
              registrationData.trainer.user.firstName
                ? `${registrationData.trainer.user.firstName || ""} ${
                    registrationData.trainer.user.lastName || ""
                  }`
                : "-"
            }}
          </div>
        </v-col>

        <v-col cols="" md style="width: 250px">
          <div class="text-ellipse-2 text-start">
            {{
              registrationData.organization &&
              registrationData.organization.name
                ? getLocalisedValue(registrationData.organization.name)
                : "-"
            }}
          </div>
        </v-col>

        <v-col cols="" md="auto" style="width: 150px">
          <div class="text-ellipse-2 text-start">
            {{ registrationData.batchNumber || "-" }}
          </div>
        </v-col>

        <v-col cols="" md="auto" style="width: 200px">
          <div class="d-flex justify-start align-center">
            <span
              :class="
                registrationData.status === 'REGISTERED'
                  ? 'primary--text'
                  : registrationData.status === 'COMPLETED'
                  ? 'green--text'
                  : registrationData.status === 'THIRDPARTY'
                  ? 'orange--text'
                  : ''
              "
              >{{ formatStatus(registrationData.status) }}</span
            >

            <v-menu
              v-if="
                havePermissionUpdateTrainingRegistration &&
                registrationData.status !== 'COMPLETED'
              "
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  :loading="statusUpdateLoading"
                >
                  <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item
                  @click="updateRegistrationStatus(item)"
                  v-for="(item, i) in registrationStatusArr"
                  :key="i"
                >
                  <v-list-item-title>{{ formatStatus(item) }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <v-btn v-else icon disabled style="visibility: hidden">
              <v-icon>mdi-chevron-down</v-icon>
            </v-btn>
          </div>
        </v-col>

        <v-col cols="" md="auto" style="width: 250px">
          <!--@deprecated payment status replaced with employee id-->
          <!--          <div
            class="d-flex justify-end justify-md-center align-center ps-md-3"
            v-if="registrationData.invoice"
            :style="$vuetify.breakpoint.mdAndUp ? 'width: 110px' : ''"
          >
            <span
              :class="
                registrationData.invoice.status === 'PAID'
                  ? 'green&#45;&#45;text'
                  : registrationData.invoice.status === 'UNPAID'
                  ? 'red&#45;&#45;text'
                  : 'primary&#45;&#45;text'
              "
            >
              {{
                registrationData.invoice.status
                  ? registrationData.invoice.status.charAt(0).toUpperCase() +
                    registrationData.invoice.status.slice(1).toLowerCase()
                  : "-"
              }}
            </span>

            <v-menu v-if="havePermissionUpdateTrainingRegistration">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  :loading="invoiceStatusUpdateLoading"
                >
                  <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item
                  @click="
                    updateInvoiceStatus(registrationData.invoice._id, item)
                  "
                  v-for="(item, i) in invoiceStatusArr"
                  :key="i"
                >
                  <v-list-item-title>{{ item }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>-->

          <div class="d-flex align-center">
            {{
              registrationData.employee && registrationData.employee.user
                ? registrationData.employee.user.civilIdOrPassport || "-"
                : "-"
            }}
          </div>
        </v-col>

        <v-col
          cols=""
          md="auto"
          class="text-start d-flex align-center"
          style="width: 180px"
        >
          <div>
            {{
              registrationData.startDate
                ? moment(parseInt(registrationData.startDate)).format(
                    "DD MMM YYYY"
                  )
                : "-"
            }}
          </div>

          <span
            v-if="registrationData.status !== 'COMPLETED'"
            class="ms-2 mt-1"
            v-on:click.stop
          >
            <v-menu
              v-if="havePermissionUpdateTrainingRegistration"
              v-model="menu1"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <edit-btn
                  v-if="registrationData.startDate"
                  @editDate="editStartDate"
                  :height="'27'"
                  :width="'27'"
                  :minusIconSize="'20'"
                  :pencilIconSize="'20'"
                  :loading="editBtnLoading1"
                  v-bind="attrs"
                  v-on="on"
                />
              </template>

              <v-date-picker color="primary" v-model="date1" no-title>
                <v-spacer></v-spacer>

                <v-btn text color="primary" @click="menu1 = false">
                  Cancel
                </v-btn>

                <v-btn
                  v-if="
                    date1 !==
                    moment(parseInt(registrationData.startDate)).format(
                      'YYYY-MM-DD'
                    )
                  "
                  text
                  color="primary"
                  @click="updateStartDate"
                >
                  Update
                </v-btn>
              </v-date-picker>
            </v-menu>
          </span>
        </v-col>

        <v-col cols="" md="auto" class="text-start" style="width: 200px">
          <div>
            <!--@deprecated end date, replaced with certificate expiry-->
            <!--            {{
              registrationData.endDate
                ? moment(parseInt(registrationData.endDate)).format(
                    "DD MMM YYYY"
                  )
                : "-"
            }}-->

            {{ generateCertificateExpiryDate(registrationData) }}
          </div>

          <!--@deprecated end date, replaced with certificate expiry-->
          <!--          <span v-if="registrationData.status !== 'COMPLETED'" v-on:click.stop>
            <v-menu
              v-if="havePermissionUpdateTrainingRegistration"
              v-model="menu2"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <edit-btn
                  v-if="registrationData.endDate"
                  @editDate="editEndDate"
                  :height="'27'"
                  :width="'27'"
                  :minusIconSize="'20'"
                  :pencilIconSize="'20'"
                  :loading="editBtnLoading2"
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker color="primary" v-model="date2" no-title>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menu2 = false"
                  >Cancel</v-btn
                >
                <v-btn
                  v-if="
                    date2 !==
                    moment(parseInt(registrationData.endDate)).format(
                      'YYYY-MM-DD'
                    )
                  "
                  text
                  color="primary"
                  @click="updateEndDate"
                  >Update</v-btn
                >
              </v-date-picker>
            </v-menu>
          </span>-->
        </v-col>

        <div>
          <v-btn
            v-if="havePermissionDeleteTrainingRegistration"
            icon
            depressed
            color="error"
            @click.stop="deleteTrainingRegistration"
          >
            <v-icon> mdi-trash-can-outline </v-icon>
          </v-btn>

          <v-btn v-else icon depressed color="error" style="visibility: hidden">
            <v-icon> mdi-trash-can-outline </v-icon>
          </v-btn>
        </div>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import EditBtn from "./EditBtn.vue";

import { updateTrainingRegistration } from "../../course-module/methods/updateTrainingRegistration";
import { createOrUpdateTrainingRegistrationInvoice } from "../../course-module/methods/createOrUpdateTrainingRegistrationInvoice";
import { hasPermission } from "@/app/user-module/helpers/authHelper";

export default {
  components: { EditBtn },
  props: {
    registrationData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      registrationStatusArr: ["REGISTERED", "THIRDPARTY", "COMPLETED"],
      invoiceStatusArr: ["PAID", "UNPAID"],
      date1: null,
      date2: null,
      menu1: false,
      menu2: false,
      statusUpdateLoading: false,
      invoiceStatusUpdateLoading: false,
      editBtnLoading1: false,
      editBtnLoading2: false,
    };
  },
  computed: {
    havePermissionUpdateTrainingRegistration() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["UPDATE_TRAINING_REGISTRATION"],
        restrictOrganizationManager:
          this.$store.state.authenticatedUser?.isOrganizationManager,
      });
    },
    havePermissionDeleteTrainingRegistration() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["DELETE_TRAINING_REGISTRATION"],
        restrictOrganizationManager:
          this.$store.state.authenticatedUser?.isOrganizationManager,
      });
    },
  },
  methods: {
    navigateToEmployeeProfilePage(userId) {
      if (userId) {
        this.$router.push({
          name: "EmployeeProfile",
          params: { userId },
        });
      }
    },
    editStartDate() {
      this.date1 = this.$moment(
        parseInt(this.registrationData.startDate)
      ).format("YYYY-MM-DD");
      this.menu1 = true;
    },
    editEndDate() {
      this.date2 = this.$moment(parseInt(this.registrationData.endDate)).format(
        "YYYY-MM-DD"
      );
      this.menu2 = true;
    },
    formatDateServer(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${year}-${month}-${day}`;
    },
    async updateStartDate() {
      this.menu1 = false;
      this.editBtnLoading1 = true;
      await updateTrainingRegistration({
        id: this.registrationData._id,
        input: {
          startDate: this.formatDateServer(this.date1),
        },
      }).then(result => {
        this.editBtnLoading1 = false;
      });
    },
    async updateEndDate() {
      this.menu2 = false;
      this.editBtnLoading2 = true;
      await updateTrainingRegistration({
        id: this.registrationData._id,
        input: {
          endDate: this.formatDateServer(this.date2),
        },
      }).then(result => {
        this.editBtnLoading2 = false;
      });
    },
    async updateRegistrationStatus(status) {
      this.statusUpdateLoading = true;
      await updateTrainingRegistration({
        id: this.registrationData._id,
        input: { status: status },
      }).then(result => {
        this.statusUpdateLoading = false;
      });
    },
    async updateInvoiceStatus(id, status) {
      this.invoiceStatusUpdateLoading = true;
      await createOrUpdateTrainingRegistrationInvoice(id, status).then(
        result => {
          this.invoiceStatusUpdateLoading = false;
        }
      );
    },
    deleteTrainingRegistration() {
      this.$emit("onDelete", this.registrationData._id);
    },
    formatStatus(status) {
      if (!status) return "-";
      if (status === "THIRDPARTY") return "ThirdParty";
      return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
    },
  },
};
</script>
